import apiClient from './client';

export type NotificationType =
  | 'audit_completed'
  | 'recommendations_ready'
  | 'plan_limit_warning'
  | 'weekly_digest'
  | 'team_invitation'
  | 'fraud_order_flagged';

export interface Notification {
  id: number;
  type: NotificationType;
  type_label: string;
  title: string;
  message: string;
  data: Record<string, unknown> | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string | null;
}

export interface NotificationPreferences {
  audit_completed_email: boolean;
  audit_completed_in_app: boolean;
  recommendations_ready_email: boolean;
  recommendations_ready_in_app: boolean;
  plan_limit_warning_email: boolean;
  plan_limit_warning_in_app: boolean;
  weekly_digest_email: boolean;
  weekly_digest_in_app: boolean;
}

export interface NotificationListResponse {
  success: boolean;
  data: Notification[];
  meta: { current_page: number; last_page: number; per_page: number; total: number };
}

export const notificationsApi = {
  list(params: { unread_only?: 0 | 1; per_page?: number; page?: number } = {}): Promise<NotificationListResponse> {
    return apiClient.get('/notifications', { params }).then((r) => r.data);
  },

  count(): Promise<{ success: boolean; data: { unread: number } }> {
    return apiClient.get('/notifications/count').then((r) => r.data);
  },

  markRead(id: number): Promise<{ success: boolean; data: Notification }> {
    return apiClient.patch(`/notifications/${id}/read`).then((r) => r.data);
  },

  markAllRead(): Promise<{ success: boolean; data: { unread: number } }> {
    return apiClient.patch('/notifications/read-all').then((r) => r.data);
  },

  getPreferences(): Promise<{ success: boolean; data: NotificationPreferences }> {
    return apiClient.get('/notifications/preferences').then((r) => r.data);
  },

  updatePreferences(data: Partial<NotificationPreferences>): Promise<{ success: boolean; data: NotificationPreferences }> {
    return apiClient.put('/notifications/preferences', data).then((r) => r.data);
  },
};
